import { useState, useEffect } from 'react';

//Use status init when the initial render requires a special treatment
type status = 'init' | 'yes' | 'no';

export function useIsIntersecting(targetId: string) {
  const [intersectionTarget, setIntersectionTarget] = useState<Element | null>(
    null
  );

  const [target, setTarget] = useState<status>('init');

  useEffect(() => {
    const handleIntersect = (e: IntersectionObserverEntry[]) => {
      const event = e[0];
      const { isIntersecting } = event;
      if (target === 'init' && !isIntersecting) {
        setTarget('no');
        return;
      }
      if (target === 'no' && isIntersecting) {
        setTarget('yes');
        return;
      }

      if (target === 'yes' && !isIntersecting) {
        setTarget('no');
        return;
      }
    };
    const observer = new IntersectionObserver(handleIntersect);
    if (intersectionTarget) {
      observer.observe(intersectionTarget);
    }
    return () => {
      if (intersectionTarget) {
        observer.unobserve(intersectionTarget);
      }
    };
  }, [intersectionTarget, target]);

  useEffect(() => {
    const handler = () => {
      const target = document.querySelector(`#${targetId}`);
      if (target) {
        setIntersectionTarget(target);
        clearInterval(intervalObj);
      }
    };
    const intervalObj = window.setInterval(handler);
    return () => {
      clearInterval(intervalObj);
    };
  }, [targetId]);

  return target;
}
